<template>
  <div id="wrapper" v-cloak>
    <!-- 面包屑 -->
    <div style="padding-bottom: 10px">
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item @click.native="goIndex">首页</el-breadcrumb-item>
        <el-breadcrumb-item>批量上传</el-breadcrumb-item>
      </el-breadcrumb> -->
    </div>

    <div style="height: 1px; margin: 10px 0; background-color: white"></div>

    <!-- 操作按钮区 -->
    <div style="display: flex; align-items: center; margin: 10px 0;">
      <el-button @click="handleAdd" type="primary" class="common-button">新增账户</el-button>

      <el-button type="primary" class="common-button" style="width: 100px; height: 40px; padding: 0px; margin-right: 2px;">
        <a :href="downloadTemplateUrl" style="color: white; display: block; height: 40px; line-height: 40px; text-decoration: none;">下载模板</a>
      </el-button>

      <el-button size="small" type="primary" class="common-button" style="height: 40px;" @click="sedialogFormVisible = true">批量添加</el-button>
    </div>

    <!-- idsname查询区 -->
    <el-card style="margin: 12px 0;">
      <div slot="header" class="query-card-header">
        <span>按账户名查询最新数据（可编辑）</span>
        <div>
          <el-button type="primary" size="small" :loading="queryLoading" @click="handleQueryByIdsname">查询</el-button>
          <el-button
            v-if="queryResultList.length"
            type="success"
            size="small"
            :loading="querySaveLoading"
            @click="handleSaveQueryResult"
          >保存编辑</el-button>
        </div>
      </div>
      <el-input
        type="textarea"
        :rows="4"
        v-model="queryIdsnameText"
        placeholder="请输入账户名，多个可换行、逗号或空格分隔"
      />
    </el-card>

    <!-- 查询结果 -->
    <el-table v-if="queryResultList.length" :data="queryResultList" border stripe style="width: 100%; margin-bottom: 16px;">
      <el-table-column prop="idsname" label="账户名" min-width="160">
        <template slot-scope="scope">
          <el-input v-model="scope.row.idsname" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="username" label="客户" min-width="140">
        <template slot-scope="scope">
          <el-input v-model="scope.row.username" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="twoname" label="产品" min-width="140">
        <template slot-scope="scope">
          <el-input v-model="scope.row.twoname" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="url" label="推广网址" min-width="260">
        <template slot-scope="scope">
          <el-input v-model="scope.row.url" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="baoguangurl" label="曝光监测" min-width="260">
        <template slot-scope="scope">
          <el-input v-model="scope.row.baoguangurl" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="xiaoshuourl" label="点击监测" min-width="260">
        <template slot-scope="scope">
          <el-input v-model="scope.row.xiaoshuourl" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="token" label="Token" min-width="260">
        <template slot-scope="scope">
          <el-input v-model="scope.row.token" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="ids" label="uuid" min-width="200">
        <template slot-scope="scope">
          <el-input v-model="scope.row.ids" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="planName" label="计划名称" min-width="180">
        <template slot-scope="scope">
          <el-input v-model="scope.row.planName" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="builtInRpkDeepLink" label="内置快应用链接" min-width="260">
        <template slot-scope="scope">
          <el-input v-model="scope.row.builtInRpkDeepLink" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="adcreativedeeplink" label="创意DeepLink" min-width="260">
        <template slot-scope="scope">
          <el-input v-model="scope.row.adcreativedeeplink" size="mini" class="copyable-cell" />
        </template>
      </el-table-column>
      <el-table-column prop="channelId" label="渠道号" min-width="150">
        <template slot-scope="scope">
          <el-input v-model="scope.row.channelId" size="mini" style="width: 100%" />
        </template>
      </el-table-column>
      <el-table-column prop="apkId" label="渠道包id" min-width="150">
        <template slot-scope="scope">
          <el-input v-model="scope.row.apkId" size="mini" style="width: 100%" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑弹窗 -->
    <el-dialog title="账户信息" :visible.sync="dialogFormVisible" width="40%" :close-on-click-modal="false">
      <el-form :model="entity" :rules="formRules" ref="entityForm">
        <el-form-item label="客户" label-width="120px" prop="username">
          <el-input v-model="entity.username" autocomplete="off" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="产品" label-width="120px" prop="twoname">
          <el-input v-model="entity.twoname" autocomplete="off" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="推广网址" label-width="120px">
          <el-input v-model="entity.url" autocomplete="off" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="点击监测" label-width="120px">
          <el-input v-model="entity.xiaoshuourl" autocomplete="off" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="token" label-width="120px" prop="token">
          <el-input v-model="entity.token" autocomplete="off" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="账户名" label-width="120px" prop="idsname">
          <el-input v-model="entity.idsname" autocomplete="off" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="uuid" label-width="120px" prop="ids">
          <el-input v-model="entity.ids" autocomplete="off" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="计划名称" label-width="120px">
          <el-input v-model="entity.planName" autocomplete="off" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="内置快应用链接" label-width="120px">
          <el-input v-model="entity.builtInRpkDeepLink" autocomplete="off" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="渠道号" label-width="120px">
          <el-input v-model="entity.channelId" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="渠道包id" label-width="120px">
          <el-input v-model="entity.apkId" style="width: 80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave" :loading="saveLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 批量上传弹窗 -->
    <el-dialog title="上传文件" :visible.sync="sedialogFormVisible" width="30%" :close-on-click-modal="false">
      <el-form style="display: inline-block; margin-left: 30px">
        <el-upload
          class="upload-demo"
          ref="upload"
          accept=".xls,.xlsx"
          action=""
          :auto-upload="false"
          :show-file-list="true"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :http-request="uploadFile"
          :limit="1"
          :on-exceed="handleExceed">
          <el-button slot="trigger" size="small" type="primary" style="height: 40px">选择文件</el-button>
          <el-text style="color: red; margin-left: 10px;">一次只能上传一个文件</el-text>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex; justify-content: center;">
        <el-button style="height: 40px" size="small" @click="sedialogFormVisible = false">取 消</el-button>
        <el-button style="margin-left: 22px; height: 40px" size="small" type="primary" @click="submitUpload" :loading="uploadLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

const BASE_URL = 'https://control.zjwec.cn'

export default {
  name: 'VivoBatchUpload',
  data() {
    return {
      user: {},
      dialogFormVisible: false,
      sedialogFormVisible: false,
      saveLoading: false,
      uploadLoading: false,
      queryLoading: false,
      querySaveLoading: false,
      fileList: [],
      queryIdsnameText: '',
      queryResultList: [],
      entity: {
        username: '',
        twoname: '',
        url: '',
        xiaoshuourl: '',
        token: '',
        idsname: '',
        ids: '',
        planName: '',
        builtInRpkDeepLink: '',
        channelId: null,
        apkId: null
      },
      formRules: {
        username: [{ required: true, message: '请输入客户', trigger: 'blur' }],
        twoname: [{ required: true, message: '请输入产品', trigger: 'blur' }],
        token: [{ required: true, message: '请输入token', trigger: 'blur' }],
        idsname: [{ required: true, message: '请输入账户名', trigger: 'blur' }],
        ids: [{ required: true, message: '请输入uuid', trigger: 'blur' }]
      }
    }
  },
  computed: {
    downloadTemplateUrl() {
      return BASE_URL + '/api/batchuser/downLoadTemplate'
    }
  },
  created() {
    this.user = sessionStorage.getItem('user')
      ? JSON.parse(sessionStorage.getItem('user'))
      : {}
  },
  methods: {
    // 返回首页
    goIndex() {
      if (this.$parent && this.$parent.changeIndex) {
        this.$parent.changeIndex('index')
      } else {
        this.$router.push('/')
      }
    },

    // 新增账户
    handleAdd() {
      this.entity = {
        username: '',
        twoname: '',
        url: '',
        xiaoshuourl: '',
        token: '',
        idsname: '',
        ids: '',
        planName: '',
        builtInRpkDeepLink: '',
        channelId: null,
        apkId: null
      }
      this.dialogFormVisible = true
      this.$nextTick(() => {
        if (this.$refs.entityForm) {
          this.$refs.entityForm.clearValidate()
        }
      })
    },

    // 空字符串转 null，避免后端 Long 字段反序列化报错（输入框清空后值是 ''）
    normalizeChannelFields(obj) {
      if (obj.channelId === '') {
        obj.channelId = null
      }
      if (obj.apkId === '') {
        obj.apkId = null
      }
      return obj
    },

    // 保存账户（新增/修改）
    handleSave() {
      this.$refs.entityForm.validate(async (valid) => {
        if (!valid) return

        this.saveLoading = true
        try {
          const type = this.entity.id ? 'PUT' : 'POST'
          const res = await axios({
            url: BASE_URL + '/api/batchuser',
            method: type,
            headers: { 'Content-Type': 'application/json' },
            data: JSON.stringify(this.normalizeChannelFields(this.entity))
          })

          const data = res.data
          if (data.code === '0' || data.code === 200) {
            this.$message.success('保存成功')
            this.dialogFormVisible = false
            // 重新获取用户详情
            this.refreshUserDetail()
          } else {
            this.$message.error(data.msg || '保存失败')
          }
        } catch (error) {
          console.error('保存失败:', error)
          this.$message.error('网络错误，保存失败')
        } finally {
          this.saveLoading = false
        }
      })
    },

    // 刷新用户详情
    refreshUserDetail() {
      if (this.user.username) {
        axios.get(BASE_URL + '/api/user/detail/' + this.user.username)
          .then(res => {
            if (res.data && res.data.data) {
              this.user = res.data.data
              sessionStorage.setItem('user', JSON.stringify(this.user))
            }
          })
          .catch(err => {
            console.error('获取用户详情失败:', err)
          })
      }
    },

    // 按 idsname 查询最新数据
    async handleQueryByIdsname() {
      const idsnames = this.queryIdsnameText
        .split(/[\n,，\s]+/)
        .map(item => item.trim())
        .filter(item => item)

      if (!idsnames.length) {
        this.$message.warning('请输入 idsname')
        return
      }

      this.queryLoading = true
      try {
        const res = await axios({
          url: BASE_URL + '/api/batchuser/queryByNames',
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: JSON.stringify(idsnames)
        })
        const data = res.data
        if (data.code === '0' || data.code === 200) {
          this.queryResultList = data.data || []
          this.$message.success('查询成功，共 ' + this.queryResultList.length + ' 条')
        } else {
          this.queryResultList = []
          this.$message.error(data.msg || '查询失败')
        }
      } catch (error) {
        console.error('查询失败:', error)
        this.queryResultList = []
        this.$message.error('网络错误，查询失败')
      } finally {
        this.queryLoading = false
      }
    },

    // 保存查询结果中的单元格编辑
    async handleSaveQueryResult() {
      if (!this.queryResultList.length) {
        this.$message.warning('没有可保存的数据')
        return
      }

      const invalidRow = this.queryResultList.find(row => !row.idsname || !row.username || !row.twoname || !row.token || !row.ids)
      if (invalidRow) {
        this.$message.warning('账户名、客户、产品、Token、uuid 不能为空')
        return
      }

      this.querySaveLoading = true
      try {
        const saveList = this.queryResultList.map(row => axios({
          url: BASE_URL + '/api/batchuser',
          method: row.id ? 'PUT' : 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: JSON.stringify(this.normalizeChannelFields(row))
        }))
        const results = await Promise.all(saveList)
        const allSuccess = results.every(res => {
          const data = res.data || {}
          return data.code === '0' || data.code === 200
        })
        if (allSuccess) {
          this.$message.success('保存成功')
          await this.handleQueryByIdsname()
        } else {
          this.$message.error('部分数据保存失败')
        }
      } catch (error) {
        console.error('保存查询结果失败:', error)
        this.$message.error('网络错误，保存失败')
      } finally {
        this.querySaveLoading = false
      }
    },

    // 上传前校验
    beforeUpload(file) {
      const isValidType =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel'
      if (!isValidType) {
        this.$message.error('请上传 .xlsx 或 .xls 格式的文件')
        return false
      }
      return true
    },

    // 超出文件数量限制
    handleExceed() {
      this.$message.warning('一次只能上传一个文件，请先移除已有文件')
    },

    // 提交上传
    submitUpload() {
      const files = this.$refs.upload.uploadFiles
      if (!files || files.length === 0) {
        this.$message.warning('请选择文件后再点确定')
        return
      }
      this.$refs.upload.submit()
    },

    // 自定义上传逻辑
    async uploadFile(param) {
      this.uploadLoading = true
      const file = param.file
      const formData = new FormData()
      formData.append('file', file)

      try {
        const res = await axios({
          url: BASE_URL + '/api/batchuser/file/upload',
          method: 'POST',
          data: formData,
          transformRequest: [
            function (data, headers) {
              delete headers.post['Content-Type']
              return data
            }
          ]
        })

        const data = res.data
        if (data.code === '0' || data.code === 200) {
          param.onSuccess()
        } else {
          param.onError(new Error(data.msg || '解析数据报错，请检查你的模板中的数据重新上传'))
        }
      } catch (error) {
        console.error('上传失败:', error)
        param.onError(error)
      } finally {
        this.uploadLoading = false
      }
    },

    // 上传成功回调
    handleUploadSuccess() {
      this.$message.success('上传成功')
      this.sedialogFormVisible = false
      this.fileList = []
    },

    // 上传失败回调
    handleUploadError(err) {
      this.$message.error(err.message || '上传失败')
    }
  }
}
</script>

<style scoped>
#wrapper {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  padding: 16px;
}

[v-cloak] {
  display: none;
}

.common-button {
  height: 40px;
}

.query-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.copyable-cell /deep/ .el-input__inner {
  user-select: text;
  cursor: text;
}

.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/vivo/batchUpload.vue